import getMaxTotalOdd from 'Utils/getMaxTotalOdd';
// Used atrium & betslip total odds value
export const calculateOddValue = data => {
  if (data?.length === 0)  return 0;

  const maxTotalOdd = getMaxTotalOdd();

  return data.reduce((previousValue, current) => {
    if (previousValue >= maxTotalOdd)
      return maxTotalOdd;
    return (previousValue * (current?.topWinOdds ? current.topWinOdds : current?.odds));
  }, 1);
};

